import React, { FC } from 'react';
import BreadCrumbAntrag from './BreadCrumbAntrag';

const ApplicationBreadcrumbs: FC<{}> = () => {
	return <BreadCrumbAntrag />;
};

export default ApplicationBreadcrumbs;
